module.exports = __webpack_public_path__ + "static/media/image_13.2e2d7527.png";